'use client';

import { cn } from '@heroui/react';
import { Icon } from '@iconify/react';
import NextImage from 'next/image';

interface NavRailItemProps {
    /** Iconify slug (without `lucide:`). Ignored when `iconSrc` is set. */
    icon?: string;
    /** Local image asset to render instead of an Iconify icon (e.g. the MFour brand mark for Home). */
    iconSrc?: string;
    label: string;
    /** Background for the icon chip. Omit for a neutral dark chip (Home). */
    color?: string;
    isActive?: boolean;
    onClick?: () => void;
}

/** One collapsed-rail icon+label button (Home / a section shortcut). */
export function NavRailItem({ icon, iconSrc, label, color, isActive, onClick }: NavRailItemProps) {
    return (
        <button
            type="button"
            onClick={onClick}
            className="flex w-full flex-col items-center gap-1 rounded-large py-1.5 transition-colors hover:bg-[#F3F8FF]"
        >
            <span
                className={cn('flex h-7 w-7 items-center justify-center rounded-lg text-white', {
                    'bg-foreground': !color,
                })}
                style={color ? { background: color } : undefined}
            >
                {iconSrc ? (
                    <NextImage src={iconSrc} alt="" width={12} height={13} />
                ) : (
                    <Icon icon={`lucide:${icon}`} width={15} height={15} />
                )}
            </span>
            <span
                className={cn('text-[10.5px] leading-none', {
                    'font-semibold text-foreground': isActive,
                    'text-default-500': !isActive,
                })}
            >
                {label}
            </span>
        </button>
    );
}

NavRailItem.displayName = 'NavRailItem';
